import * as $ from 'jquery';
$('.js-request-print').click(function () {
    $('select[name=print]').val($(this).parent().find('.productTitle').text().trim()).trigger('change');
});
